module.exports = __webpack_public_path__ + "static/media/garage-cafe.543aebd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/garage-cafe.jpg
// module id = 378
// module chunks = 0